import { PageContainer } from './styles';

export default PageContainer;
